import { Component } from '@angular/core';
import { AppHeader } from '../../components/header/header';
import {MobileMenu} from '../../components/mobile-menu/mobile-menu';

@Component({
  selector: 'app-about-page',
  standalone: true,
  imports: [AppHeader, MobileMenu],
  templateUrl: './about-page.html',
  styleUrl: './about-page.scss'
})
export class AboutPage {}
